import { formatValueForSelectables } from "./sub_functions/fomatValueForSeletables";

export const standardizeEditGrid = (initialUiArray, ListColumnInfo) => {
  const FilteredListColumnInfo = ListColumnInfo.filter(
    (column) => column.VisibleColumn
  );
  const FormattedArray = initialUiArray?.UiValue?.DataTableArray?.map(
    (dataTable) => {
      return dataTable?.map((innertable) => {
        return FilteredListColumnInfo.map((column) => {
          if (innertable?.id === column?.ElsRecord?.Id) {
            if (
              column.ElsRecord.Type === "RadCheckedDropDownList" ||
              column.ElsRecord.Type === "ComboBox"
            ) {
              const value = formatValueForSelectables(
                innertable.idcommand,
                innertable.label,
                column.ElsRecord.Type
              );
              return {
                ListDefaultAnswer: column?.ElsRecord?.ListDefaultAnswer,
                base64: "",
                element: column ?? "",
                idcommand: "",
                iddetail: column?.IdColumn ?? "",
                name: column?.HeaderColumn ?? "",
                value: value.some((val) => val.id === 0 || val.ItemValue === 0)
                  ? ""
                  : value,
              };
            } else {
              return {
                base64: "",
                element: column ?? "",
                iddetail: innertable.id ?? "",
                name: column?.HeaderColumn ?? "",
                value:
                  Number(innertable.label) === 0
                    ? ""
                    : column?.ElsRecord.Type === "CheckBox" ||
                      column?.ElsRecord?.Type === "RadioButton"
                    ? Number(innertable.label)
                    : innertable.label ?? "",
              };
            }
          }
        }).filter((fl) => fl)[0];
      });
    }
  );
  return FormattedArray;
};

// formatValueForSelectables(
//   innertable.idcommand,
//   innertable.label,
//   column.ElsRecord.Type
// ),
